import { Button } from '@sunstone/ui';
import { Link, useNavigate } from 'react-router';
import { PageHeader } from '@/components/ui/PageHeader';
import { MemberList } from '@/features/users/MemberList';
import { routes } from '@/lib/routes';

export function PlatformUsersPage() {
  const navigate = useNavigate();
  return (
    <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <PageHeader
        title="Platform Users"
        description="Users with no tenant — full platform access today, any platform-wide role going forward."
        action={
          <Button size="sm" asChild>
            <Link to={routes.invitePlatformUser()}>Invite Platform User</Link>
          </Button>
        }
      />
      <MemberList
        scope="platform_admins"
        onRowClick={(user) => navigate(routes.platformUserDetail(user.id))}
      />
    </div>
  );
}
